















import Vue, { PropType } from 'vue';
import SectionItemForm, {
  FormDataInterface,
} from '@/containers/cv-section-gallery-item/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionGalleryItemStoreEdit from '@/store/modules/cvSectionGalleryItemEdit';
import { CvSectionGalleryItem } from '@/../gen';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    SectionItemForm,
  },
  props: {
    cvId: {
      type: [String, Number],
      required: true,
    },
    sectionItem: {
      type: Object as PropType<CvSectionGalleryItem>,
      required: true,
    },
  },
  methods: {
    async onSubmit({ title, image, description, _url }: FormDataInterface) {
      const { cv_section_gallery_id, id } = this.sectionItem;
      await this.$store.dispatch(
        CvSectionGalleryItemStoreEdit.UpdateCvSectionGalleryItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_gallery_id,
            id,
          },
          body: {
            title: title || '',
            image: (image as any) instanceof File ? (image as any) : undefined,
            description: description || '',
            _url: _url || '',
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.updated));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
    async onDelete() {
      const { cv_section_gallery_id, id } = this.sectionItem;
      await this.$store.dispatch(
        CvSectionGalleryItemStoreEdit.DeleteCvSectionGalleryItem.namespaced({
          params: {
            cv_id: this.cvId,
            cv_section_gallery_id,
            id,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.deleted));
      // refresh sections
      this.$store.dispatch(
        CvStore.GetCvCvSections.namespaced({ cv_id: this.cvId })
      );
      this.$router.push({ name: 'cv_edit_path' });
    },
  },
});
